exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".braintree-form__label,.braintree-sheet__text{font-family:engrezbold,sans-serif!important;font-weight:700!important}.braintree-form__notice-of-collection{display:none}.braintree-form-cardholder-name{opacity:.5!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./resources/js/components/Braintree/DropIn.css
// module id = vGIe
// module chunks = 0